import { render, staticRenderFns } from "./FinanceNeedsDetail.vue?vue&type=template&id=4585fb5a&scoped=true&"
import script from "./FinanceNeedsDetail.vue?vue&type=script&lang=js&"
export * from "./FinanceNeedsDetail.vue?vue&type=script&lang=js&"
import style0 from "./FinanceNeedsDetail.vue?vue&type=style&index=0&id=4585fb5a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4585fb5a",
  null
  
)

export default component.exports